import React, { useCallback, useEffect, useMemo, useState } from "react";
import moment from "moment";
import { Projects } from "../../services/projectsService";
import { PageHeader } from "../components/ApplicationShell";
import ResponsiveDataTable from "../components/ResponsiveDataTable";

const formatDate = (value) => value && moment(value).isValid() ? moment(value).format("D MMM YYYY, HH:mm") : "Not specified";
const ProjectsLibrary = () => {
  const [projects, setProjects] = useState([]);
  const [pageInfo, setPageInfo] = useState({ last_page: 1, total: 0 });
  const [query, setQuery] = useState({ filters: {}, page: 0, pageSize: 10, sortBy: "number", sortOrder: "asc" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const loadProjects = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const response = await Projects.getAllProjects(query.page, query.pageSize, query.sortBy, query.sortOrder, query.filters);
      const records = response?.data || [];
      setProjects(records);
      setPageInfo({ last_page: Number(response?.last_page) || 1, total: Number(response?.total) || records.length });
    } catch (requestError) { setError(requestError?.message || "Projects could not be loaded."); }
    finally { setLoading(false); }
  }, [query]);
  useEffect(() => { loadProjects(); }, [loadProjects]);
  const columns = useMemo(() => [
    { key: "number", header: "Project number", filter: { type: "text" } },
    { key: "name", header: "Project name", filter: { type: "text" } },
    { key: "principal_contractor", header: "Principal contractor", accessor: (item) => item.principal_contractor || "Not specified", sortable: false },
    { key: "contractor", header: "Contractor", accessor: (item) => item.contractor || "Not specified", sortable: false },
    { key: "last_modified_on", header: "Last updated", accessor: (item) => formatDate(item.last_modified_on), sortValue: (item) => item.last_modified_on },
    { key: "last_modified_by", header: "Updated by", accessor: (item) => item.last_modified_by || "Not specified", sortable: false },
  ], []);
  const handleQuery = useCallback(({ filters, sortBy }) => {
    const sort = sortBy?.[0];
    setQuery((current) => {
      const next = { ...current, filters, page: 0, sortBy: sort?.id || "number", sortOrder: sort?.desc ? "desc" : "asc" };
      return JSON.stringify(next) === JSON.stringify(current) ? current : next;
    });
  }, []);
  return (<>
    <PageHeader description="SWP projects synchronised for your organisation and available during pack creation." title="SWP projects" />
    <ResponsiveDataTable caption="Project library" columns={columns} data={projects} emptyDescription="No SWP projects are available for your organisation." error={error}
      initialSort={{ key: "number", direction: "asc" }} loading={loading} manual onPageChange={(page) => setQuery((current) => ({ ...current, page }))}
      onPageSizeChange={(pageSize) => setQuery((current) => ({ ...current, page: 0, pageSize }))} onQueryChange={handleQuery} onRetry={loadProjects}
      pageCount={Math.max(pageInfo.last_page, 1)} pageIndex={query.page} pageSize={query.pageSize} pageSizeOptions={[10, 20, 50]}
      showCount={false} showExport={false} showSearch={false} title="Project library" totalRows={pageInfo.total} />
  </>);
};
export default ProjectsLibrary;
